<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <div class="response-container">
      <h1>VAHAN 01 API Response</h1>
      <b-row>
        <b-col md="3">
          <label>Vehicle No(CG07BC9186)</label>
          <model-list-select
            :list="$store.getters['commonDropdownMaster/getAllVehicleDDList']"
            v-model="vehiclenumber"
            option-value="label"
            option-text="label"
            placeholder="Select Vehicle No"
          ></model-list-select>
        </b-col>
        <b-col md="3">
          <b-button
            v-if="vehiclenumber"
            @click="getAllVAHAN01Func()"
            size="sm"
            variant="info"
            style="font-size: 0.675rem; margin-left: 5px; margin-bottom: 4px"
            >Fetch</b-button
          >
        </b-col>
      </b-row>
      <div v-if="!getAllVAHAN01 || getAllVAHAN01.stautsMessage !== 'OK'">
        <b class="text-danger">{{ "No data found." }}</b>
      </div>
      <div v-else>
        <b-row>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Registration Number:</strong>
            {{ getAllVAHAN01.rc_regn_no }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Registration Date:</strong>
            {{ getAllVAHAN01.rc_regn_dt }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Registration Upto:</strong>
            {{ getAllVAHAN01.rc_regn_upto }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Purchase Date:</strong>
            {{ getAllVAHAN01.rc_purchase_dt }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Owner Serial:</strong>
            {{ getAllVAHAN01.rc_owner_sr }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Owner Name:</strong>
            {{ getAllVAHAN01.rc_owner_name }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Father's Name:</strong>
            {{ getAllVAHAN01.rc_f_name }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>State Code:</strong>
            {{ getAllVAHAN01.state_cd }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>RTO Code:</strong>
            {{ getAllVAHAN01.rto_cd }}
          </b-col>
          <b-col md="6" class="mt-1 mb-1">
            <strong>Present Address:</strong>
            {{ getAllVAHAN01.rc_present_address }}
          </b-col>
          <b-col md="6" class="mt-1 mb-1">
            <strong>Permanent Address:</strong>
            {{ getAllVAHAN01.rc_permanent_address }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Mobile Number:</strong>
            {{ getAllVAHAN01.rc_mobile_no }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Vehicle Category:</strong>
            {{ getAllVAHAN01.rc_vch_catg }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Vehicle Class Description:</strong>
            {{ getAllVAHAN01.rc_vh_class_desc }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Chassis Number:</strong>
            {{ getAllVAHAN01.rc_chasi_no }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Engine Number:</strong>
            {{ getAllVAHAN01.rc_eng_no }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Maker Description:</strong>
            {{ getAllVAHAN01.rc_maker_desc }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Maker Model:</strong>
            {{ getAllVAHAN01.rc_maker_model }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Body Type Description:</strong>
            {{ getAllVAHAN01.rc_body_type_desc }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Fuel Description:</strong>
            {{ getAllVAHAN01.rc_fuel_desc }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Color:</strong>
            {{ getAllVAHAN01.rc_color }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Norms Description:</strong>
            {{ getAllVAHAN01.rc_norms_desc }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Fit Upto:</strong>
            {{ getAllVAHAN01.rc_fit_upto }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>NP Upto:</strong>
            {{ getAllVAHAN01.rc_np_upto }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>NP Issued By:</strong>
            {{ getAllVAHAN01.rc_np_issued_by }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Tax Upto:</strong>
            {{ getAllVAHAN01.rc_tax_upto }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Financer:</strong>
            {{ getAllVAHAN01.rc_financer }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Insurance Company:</strong>
            {{ getAllVAHAN01.rc_insurance_comp }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Insurance Policy Number:</strong>
            {{ getAllVAHAN01.rc_insurance_policy_no }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Insurance Upto:</strong>
            {{ getAllVAHAN01.rc_insurance_upto }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Manufacturing Month/Year:</strong>
            {{ getAllVAHAN01.rc_manu_month_yr }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Unladen Weight:</strong>
            {{ getAllVAHAN01.rc_unld_wt }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Gross Vehicle Weight:</strong>
            {{ getAllVAHAN01.rc_gvw }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Number of Cylinders:</strong>
            {{ getAllVAHAN01.rc_no_cyl }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Cubic Capacity:</strong>
            {{ getAllVAHAN01.rc_cubic_cap }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Seat Capacity:</strong>
            {{ getAllVAHAN01.rc_seat_cap }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Sleeper Capacity:</strong>
            {{ getAllVAHAN01.rc_sleeper_cap }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Standing Capacity:</strong>
            {{ getAllVAHAN01.rc_stand_cap }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Wheelbase:</strong>
            {{ getAllVAHAN01.rc_wheelbase }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Registered At:</strong>
            {{ getAllVAHAN01.rc_registered_at }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Status As On:</strong>
            {{ getAllVAHAN01.rc_status_as_on }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>PUCC Upto:</strong>
            {{ getAllVAHAN01.rc_pucc_upto }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>PUCC Number:</strong>
            {{ getAllVAHAN01.rc_pucc_no }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Status:</strong>
            {{ getAllVAHAN01.rc_status }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Permit Number:</strong>
            {{ getAllVAHAN01.rc_permit_no }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Permit Issue Date:</strong>
            {{ getAllVAHAN01.rc_permit_issue_dt }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Permit Valid From:</strong>
            {{ getAllVAHAN01.rc_permit_valid_from }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Permit Valid Upto:</strong>
            {{ getAllVAHAN01.rc_permit_valid_upto }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Permit Type:</strong>
            {{ getAllVAHAN01.rc_permit_type }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Permit Code:</strong>
            {{ getAllVAHAN01.rc_permit_code }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Sale Amount:</strong>
            {{ getAllVAHAN01.rc_sale_amt }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Current Address State Name:</strong>
            {{ getAllVAHAN01.rc_currentadd_statename }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Current Address District Code:</strong>
            {{ getAllVAHAN01.rc_currentadd_districtcode }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Current Address Pincode:</strong>
            {{ getAllVAHAN01.rc_currentadd_pincode }}
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import UlipService from "../../services/UlipService.js";
import CustomLoader from "../common/customLoader.vue";
import { globalPermissionStatus } from "../../helper/collection";
export default {
  beforeMount() {
    this.$store.dispatch(
      "commonDropdownMaster/setAllVehicleDDList",
      JSON.stringify({
        itemCode: "getVehicleList",
        vehicleActiveInactiveId: "1",
      })
    );
    this.$store.dispatch("setCurrentRoute", this.$route.path);
    if (globalPermissionStatus("Dashboard_Access") || globalPermissionStatus("ULIP")) {
      // this.getAllVAHAN01Func();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      vehiclenumber: "",
      getAllVAHAN01: {},
      isLoading: false,
      error: false,
      code: 200,
      message: "Success",
    };
  },

  filters: {},

  mounted() {},

  beforeDestroy() {},

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    CustomLoader,
  },

  methods: {
    async getAllVAHAN01Func() {
      let payload = {};
      this.isLoading = true;
      this.getAllVAHAN01 = null;

      if (this.vehiclenumber) {
        payload = {
          itemCode: "VAHAN01",
          funcUrl: "VAHAN/01",
          vehiclenumber: this.vehiclenumber,
        };

        payload = JSON.stringify(payload);
        UlipService.getAllUlipList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              if (data.xmlJson) {
                this.getAllVAHAN01 = data.xmlJson;
              }
              this.isLoading = false;
            }
          })
          .catch((error) => {
            console.log("Catch on getAllVAHAN01 Error: ", error);
          });
      }
    },
  },
};
</script>

<style scoped>
.response-container {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

h1 {
  font-size: 24px;
  margin-bottom: 20px;
}

ul {
  list-style: none;
  padding: 0;
}

li {
  margin-bottom: 10px;
  font-size: 18px;
}

strong {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// VAHAN01_ResponseDisplay.vue?1cc0397e